"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends14 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _qs = _interopRequireDefault(require("qs"));
var _base = _interopRequireDefault(require("./base"));
var _consts = require("../utils/consts");
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/**
 * `Service` The Automation service
 * https://platform.stoplight.autodesk.com/docs/construction-automation/96e979d552ae1-acc-automation-management-api
 */
var Automation = /*#__PURE__*/function (_Base) {
  /**
   * Create the Automation service instance.
   *
   * @param sdk - the SDK instance
   */
  function Automation(sdk) {
    var _this;
    (0, _classCallCheck2["default"])(this, Automation);
    _this = _callSuper(this, Automation, [sdk]);
    _this.listFolderAutomationsCancelTokenMap = new Map();
    _this.getAutomationCancelTokenMap = new Map();
    _this.updateAutomationCancelTokenMap = new Map();
    _this.deleteAutomationCancelTokenMap = new Map();
    _this.setScopesCancelTokenMap = new Map();
    _this.getScopesCancelTokenMap = new Map();
    _this.attachScopeCancelTokenMap = new Map();
    _this.detachScopeCancelTokenMap = new Map();
    return _this;
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  (0, _inherits2["default"])(Automation, _Base);
  return (0, _createClass2["default"])(Automation, [{
    key: "listProjectAutomations",
    value: (
    /**
     * List automations in project。
     * https://platform.stoplight.autodesk.com/docs/construction-automation/dd382f54cf12c-list-automations-in-the-project
     *
     * @param projectId - the project id.
     * @param params - query params with limit, offset, sorter and filter.
     * @param config - configurable object to overwrite request parameters.
     *
     * @returns a promise with automation results
     */
    function () {
      var _listProjectAutomations = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(projectId, params, config) {
        var _this2 = this;
        var query, path, response;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this2.listProjectAutomationsCancelToken;
                },
                setter: function setter(token) {
                  return _this2.listProjectAutomationsCancelToken = token;
                },
                clearer: function clearer() {
                  return _this2.listProjectAutomationsCancelToken = undefined;
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations").concat(query);
              _context.next = 5;
              return this.HttpService.automationV1.get(path, config);
            case 5:
              response = _context.sent;
              return _context.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function listProjectAutomations(_x, _x2, _x3) {
        return _listProjectAutomations.apply(this, arguments);
      }
      return listProjectAutomations;
    }()
    /**
     * List automations in folder
     * https://platform.stoplight.autodesk.com/docs/construction-automation/9c9198b40af80-list-automations-in-a-folder
     *
     * @param projectId - the project id.
     * @param folderUrn - the folder urn.
     * @param params - query params with limit, offset.
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns a promise with automation results
     */
    )
  }, {
    key: "listFolderAutomations",
    value: (function () {
      var _listFolderAutomations = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(projectId, folderUrn, params, config) {
        var _this3 = this;
        var query, path, response;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this3.listFolderAutomationsCancelTokenMap.get(folderUrn);
                },
                setter: function setter(token) {
                  return _this3.listFolderAutomationsCancelTokenMap.set(folderUrn, token);
                },
                clearer: function clearer() {
                  return _this3.listFolderAutomationsCancelTokenMap["delete"](folderUrn);
                }
              }), config);
              path = "/projects/".concat(projectId, "/folders/").concat(folderUrn, "/automations").concat(query);
              _context2.next = 5;
              return this.HttpService.automationV1.get(path, config);
            case 5:
              response = _context2.sent;
              return _context2.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function listFolderAutomations(_x4, _x5, _x6, _x7) {
        return _listFolderAutomations.apply(this, arguments);
      }
      return listFolderAutomations;
    }()
    /**
     * Get an automation by id.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/0f5107d4fe33a-get-an-automation-by-id
     *
     * @param projectId - the project id.
     * @param automationId - the automation id.
     * @param params - query params.
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns with shape of id, name, triggers, conditions, action
     */
    )
  }, {
    key: "getAutomation",
    value: (function () {
      var _getAutomation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(projectId, automationId, params, config) {
        var _this4 = this;
        var query, path, response;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this4.getAutomationCancelTokenMap.get(automationId);
                },
                setter: function setter(token) {
                  return _this4.getAutomationCancelTokenMap.set(automationId, token);
                },
                clearer: function clearer() {
                  return _this4.getAutomationCancelTokenMap["delete"](automationId);
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations/").concat(automationId).concat(query);
              _context3.next = 5;
              return this.HttpService.automationV1.get(path, config);
            case 5:
              response = _context3.sent;
              return _context3.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getAutomation(_x8, _x9, _x10, _x11) {
        return _getAutomation.apply(this, arguments);
      }
      return getAutomation;
    }()
    /**
     * Create an automation.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/ae9916fd7de25-create-an-automation
     *
     * @param projectId - the project id.
     * @param payload -, with shape of `name`, `triggers`, `conditions`, `action`, `scopes`.
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns with shape of id, name, triggers, conditions, action
     */
    )
  }, {
    key: "createAutomation",
    value: (function () {
      var _createAutomation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(projectId, payload, config) {
        var _this5 = this;
        var path, response;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this5.createAutomationCancelToken;
                },
                setter: function setter(token) {
                  return _this5.createAutomationCancelToken = token;
                },
                clearer: function clearer() {
                  return _this5.createAutomationCancelToken = undefined;
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations");
              _context4.next = 4;
              return this.HttpService.automationV1.post(path, payload, config);
            case 4:
              response = _context4.sent;
              return _context4.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function createAutomation(_x12, _x13, _x14) {
        return _createAutomation.apply(this, arguments);
      }
      return createAutomation;
    }()
    /**
     * Update an automation.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/4059340b1ec75-update-an-automation
     *
     * @param projectId - the project id.
     * @param automationId - the automation id.
     * @param payload -, with shape of name, triggers, conditions, action
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns with shape of id, name, triggers, conditions, action
     */
    )
  }, {
    key: "updateAutomation",
    value: (function () {
      var _updateAutomation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(projectId, automationId, payload, config) {
        var _this6 = this;
        var path, response;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this6.updateAutomationCancelTokenMap.get(automationId);
                },
                setter: function setter(token) {
                  return _this6.updateAutomationCancelTokenMap.set(automationId, token);
                },
                clearer: function clearer() {
                  return _this6.updateAutomationCancelTokenMap["delete"](automationId);
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations/").concat(automationId);
              _context5.next = 4;
              return this.HttpService.automationV1.put(path, payload, config);
            case 4:
              response = _context5.sent;
              return _context5.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function updateAutomation(_x15, _x16, _x17, _x18) {
        return _updateAutomation.apply(this, arguments);
      }
      return updateAutomation;
    }()
    /**
     * Delete an automation.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/57bb8f24b2841-delete-an-automation
     *
     * @param projectId - the project id.
     * @param automationId - the automation id.
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns 204, no return data.
     */
    )
  }, {
    key: "deleteAutomation",
    value: (function () {
      var _deleteAutomation = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(projectId, automationId, config) {
        var _this7 = this;
        var path, response;
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this7.deleteAutomationCancelTokenMap.get(automationId);
                },
                setter: function setter(token) {
                  return _this7.deleteAutomationCancelTokenMap.set(automationId, token);
                },
                clearer: function clearer() {
                  return _this7.deleteAutomationCancelTokenMap["delete"](automationId);
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations/").concat(automationId);
              _context6.next = 4;
              return this.HttpService.automationV1["delete"](path, config);
            case 4:
              response = _context6.sent;
              return _context6.abrupt("return", response.data);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function deleteAutomation(_x19, _x20, _x21) {
        return _deleteAutomation.apply(this, arguments);
      }
      return deleteAutomation;
    }()
    /**
     * Batch get scope applied automation count by targetId.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/3ff5408e295e5-count-automations-by-scopes
     *
     * @param projectId - the project id.
     * @param payload - request data.
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns count of automations by scopes.
     */
    )
  }, {
    key: "countByScopes",
    value: (function () {
      var _countByScopes = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7(projectId, payload, config) {
        var _this8 = this;
        var path, response;
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this8.countByScopesCancelToken;
                },
                setter: function setter(token) {
                  return _this8.countByScopesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this8.countByScopesCancelToken = undefined;
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations:countByScopes");
              _context7.next = 4;
              return this.HttpService.automationV1.post(path, payload, config);
            case 4:
              response = _context7.sent;
              return _context7.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function countByScopes(_x22, _x23, _x24) {
        return _countByScopes.apply(this, arguments);
      }
      return countByScopes;
    }()
    /**
     * Batch get scopes by automation ids.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/f589844191fa8-query-scopes
     *
     * @param projectId - the project id.
     * @param params - with shape of limit, offset
     * @param payload -, with the shape of automationIds
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns with shape of results, pagination
     */
    )
  }, {
    key: "batchGetScopes",
    value: (function () {
      var _batchGetScopes = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(projectId, params, payload, config) {
        var _this9 = this;
        var query, path, response;
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this9.batchGetScopesCancelToken;
                },
                setter: function setter(token) {
                  return _this9.batchGetScopesCancelToken = token;
                },
                clearer: function clearer() {
                  return _this9.batchGetScopesCancelToken = undefined;
                }
              }), config);
              path = "/projects/".concat(projectId, "/scopes:query").concat(query);
              _context8.next = 5;
              return this.HttpService.automationV1.post(path, payload, config);
            case 5:
              response = _context8.sent;
              return _context8.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function batchGetScopes(_x25, _x26, _x27, _x28) {
        return _batchGetScopes.apply(this, arguments);
      }
      return batchGetScopes;
    }()
    /**
     * Get scopes by automation id.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/73712bc9a2d37-list-scopes-by-automation
     *
     * @param projectId - the project id.
     * @param automationId - the automation id.
     * @param params - query params with shape of limit, offset.
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns with shape of results, pagination
     */
    )
  }, {
    key: "getScopes",
    value: (function () {
      var _getScopes = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(projectId, automationId, params, config) {
        var _this10 = this;
        var query, path, response;
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this10.getScopesCancelTokenMap.get(automationId);
                },
                setter: function setter(token) {
                  return _this10.getScopesCancelTokenMap.set(automationId, token);
                },
                clearer: function clearer() {
                  return _this10.getScopesCancelTokenMap["delete"](automationId);
                }
              }), config);
              query = _qs["default"].stringify(params, {
                addQueryPrefix: true
              });
              path = "/projects/".concat(projectId, "/automations/").concat(automationId, "/scopes").concat(query);
              _context9.next = 5;
              return this.HttpService.automationV1.get(path, config);
            case 5:
              response = _context9.sent;
              return _context9.abrupt("return", response.data || {});
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function getScopes(_x29, _x30, _x31, _x32) {
        return _getScopes.apply(this, arguments);
      }
      return getScopes;
    }()
    /**
     * Set scopes of target automation
     * https://platform.stoplight.autodesk.com/docs/construction-automation/36197720d3b3f-set-scopes-on-an-automation
     *
     * @param projectId - the project id.
     * @param automationId - the automation id.
     * @param payload -, request payload with scopes.
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns applied scopes
     */
    )
  }, {
    key: "setScopes",
    value: (function () {
      var _setScopes = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee10(projectId, automationId, payload, config) {
        var _this11 = this;
        var path, response;
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this11.setScopesCancelTokenMap.get(automationId);
                },
                setter: function setter(token) {
                  return _this11.setScopesCancelTokenMap.set(automationId, token);
                },
                clearer: function clearer() {
                  return _this11.setScopesCancelTokenMap["delete"](automationId);
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations/").concat(automationId, "/scopes");
              _context10.next = 4;
              return this.HttpService.automationV1.put(path, payload, config);
            case 4:
              response = _context10.sent;
              return _context10.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function setScopes(_x33, _x34, _x35, _x36) {
        return _setScopes.apply(this, arguments);
      }
      return setScopes;
    }()
    /**
     * Attach one scope of target automation
     * https://platform.stoplight.autodesk.com/docs/construction-automation/f51f8812872b6-attach-a-scope-on-an-automation
     *
     * @param projectId - the project id.
     * @param automationId - the automation id.
     * @param payload -, request payload with shape of scopeType, targetId
     * @param config -  configurable object to overwrite request parameters.
     *
     * @returns with shape of scopeType, targetId
     */
    )
  }, {
    key: "attachScope",
    value: (function () {
      var _attachScope = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee11(projectId, automationId, payload, config) {
        var _this12 = this;
        var path, response;
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this12.attachScopeCancelTokenMap.get(automationId);
                },
                setter: function setter(token) {
                  return _this12.attachScopeCancelTokenMap.set(automationId, token);
                },
                clearer: function clearer() {
                  return _this12.attachScopeCancelTokenMap["delete"](automationId);
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations/").concat(automationId, "/scopes:attach");
              _context11.next = 4;
              return this.HttpService.automationV1.post(path, payload, config);
            case 4:
              response = _context11.sent;
              return _context11.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context11.stop();
          }
        }, _callee11, this);
      }));
      function attachScope(_x37, _x38, _x39, _x40) {
        return _attachScope.apply(this, arguments);
      }
      return attachScope;
    }()
    /**
     * Detach one scope of target automation.
     * https://platform.stoplight.autodesk.com/docs/construction-automation/269aa14c4a321-detach-a-scope-from-an-automation
     *
     * @param projectId - the project id.
     * @param automationId - the automation id.
     * @param payload - request payload with shape of scopeType, targetId
     * @param config -  configurable object to overwrite request parameters
     *
     * @returns with shape of scopeType, targetId
     */
    )
  }, {
    key: "detachScope",
    value: (function () {
      var _detachScope = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee12(projectId, automationId, payload, config) {
        var _this13 = this;
        var path, response;
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              config = (0, _extends14["default"])((0, _defineProperty2["default"])({}, _consts.CANCEL_KEYS, {
                getter: function getter() {
                  return _this13.detachScopeCancelTokenMap.get(automationId);
                },
                setter: function setter(token) {
                  return _this13.detachScopeCancelTokenMap.set(automationId, token);
                },
                clearer: function clearer() {
                  return _this13.detachScopeCancelTokenMap["delete"](automationId);
                }
              }), config);
              path = "/projects/".concat(projectId, "/automations/").concat(automationId, "/scopes:detach");
              _context12.next = 4;
              return this.HttpService.automationV1.post(path, payload, config);
            case 4:
              response = _context12.sent;
              return _context12.abrupt("return", response.data || {});
            case 6:
            case "end":
              return _context12.stop();
          }
        }, _callee12, this);
      }));
      function detachScope(_x41, _x42, _x43, _x44) {
        return _detachScope.apply(this, arguments);
      }
      return detachScope;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'Automation';
    }
  }]);
}(_base["default"]);
var _default = exports["default"] = Automation;